import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../style/Product.css";
import Data from "../Data/masterData";
 
const ProductCategory = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  const product = Data?.[category];

useEffect(() => {
  if (product?.subCategories?.length === 1) {
    const type = product.subCategories[0].id;
    navigate(`/product/${category}/${type}`, { replace: true });
  }
}, [product, category, navigate]);


  if (!product) {
    return <h2 className="not-found">⚠ Product Category Not Found</h2>;
  }

  return (
    <div className="product-page">
      <h1>{product?.name}</h1>
      <div className="product-grid">
        {product?.subCategories?.map((sub, idx) => (
          <div key={idx} className="product-card">
            <img src={sub.img} alt={sub.name} />
            <h3>{sub.name}</h3>
            <Link to={`/product/${category}/${sub.id}`} className="product-btn">
              View More
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductCategory;
